import { render, staticRenderFns } from "./CompactRegister.vue?vue&type=template&id=3968e34a&scoped=true&"
import script from "./CompactRegister.vue?vue&type=script&lang=js&"
export * from "./CompactRegister.vue?vue&type=script&lang=js&"
import style0 from "./CompactRegister.vue?vue&type=style&index=0&id=3968e34a&scoped=true&lang=css&"
import style1 from "./CompactRegister.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968e34a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDialog,VIcon,VRow})
